export default "__VITE_ASSET__0080ac64__"